/** @iotv/datamodel should not be dependent on @iotv/payload-definition which exports deviceEnabled types, this aims to infer from class inheritence from DeviceEnabledType */

import { DeviceEnabledType } from '@iotv/datamodel-core'

export const getDeviceEnabledTypesMap = (ModelClasses: Record<string, any>) => {
  const deviceEnabledClassNames = Object.fromEntries(
    Object.entries(ModelClasses).map(([k, clazz]) => {
      let res: [string, null | any] = [k, null]

      try {
        if (typeof clazz === 'function') {
          const x = clazz as new (...args: any[]) => any

          const xInstance = new x({})
          res[1] = xInstance instanceof DeviceEnabledType
        } else {
          res[1] = 'not model type'
        }
      } catch (e: any) {
        res[1] = e.message
      }

      return res
    }),
  )

  return deviceEnabledClassNames
}
